<template>
  <div v-show="showFormCell" class="formcell">
    <Button
      v-for="(input, idx) in inputs"
      v-show="!openedInputs.includes(input.slug)"
      :key="idx"
      type="secondary"
      icon="plus"
      size="small"
      style="margin-right: 8px"
      @click.native="handleOpen(input.slug)"
    >
      {{ input.title }}
    </Button>
  </div>
</template>

<script>
  import Button from '@/components/ui-v2/Button';

  export default {
    name: 'InputButtons',
    components: {
      Button,
    },
    props: {
      // [{
      //    title: 'title',
      //    slug: 'slug'
      // }]
      inputs: {
        type: Array,
        required: true,
      },
    },
    data() {
      return {
        openedInputs: [],
      };
    },
    computed: {
      showFormCell() {
        return this.inputs.length && this.inputs.length !== this.openedInputs.length;
      },
    },
    methods: {
      handleOpen(slug) {
        this.openedInputs.push(slug);
        this.$emit('open', slug);
      },
    },
  };
</script>
